'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var OwnerResponse = function (_a) {
    var comment = _a.comment;
    return (React__default.createElement("div", null,
        React__default.createElement(styledComponents.ResponseTitle, null, "Recent Owner Response"),
        React__default.createElement(styledComponents.Comment, null, comment)));
};

module.exports = OwnerResponse;
